import { Popover, Transition } from "@headlessui/react";
import { IconChevronDown } from "@tabler/icons-react";
import clsx from "clsx";
import { Fragment } from "react";

interface PopoverMenuProps {
  content: React.ReactNode;
  buttonText?: string;
  className?: string;
  testID?: string;
  panelClassName?: string;
  panelDivClassName?: string;
}

export default function PopoverMenu(props: PopoverMenuProps) {
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            as="div"
            className={clsx(
              "rounded relative flex justify-between items-center hover:text-gray-600 cursor-pointer",
              props.className
            )}
            test-id={props.testID}
          >
            <span>{props.buttonText}</span>
            <IconChevronDown
              className={`${open ? "rotate-180" : ""}
                  ml-2 h-5 w-5 transition duration-150 ease-in-out text-gray-700`}
              aria-hidden="true"
            />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              className={clsx(
                "absolute left-full !z-60 mt-3 w-auto max-w-sm -translate-x-full transform px-4 sm:px-0 lg:max-w-3xl",
                props.panelClassName
              )}
            >
              <div
                className={clsx(
                  "overflow-auto rounded-lg shadow-lg border border-gray-300 bg-white",
                  props.panelDivClassName
                )}
              >
                {props.content}
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
